const { pageType } = window.meta.page;

function triggerExperiment(experimentId) {
  window.experiments[`${experimentId}`] = true;
  window._conv_q.push(['executeExperiment', experimentId]);
}

(() => {
  //-----------------------------------------
  // Code that runs on all pages.
  //-----------------------------------------

  // Experiment: Hide unit price.

  const unitPriceElements = [...document.querySelectorAll('unit-price')];

  if (unitPriceElements.length > 0) {
    // Add intersection observer to check if any element is in viewport or about to enter the
    // viewport.

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            triggerExperiment('1004147531');

            // CLean up observer once experiment has been triggered.
            observer.disconnect();
          }
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1,
      }
    );

    unitPriceElements.forEach((element) => {
      observer.observe(element);
    });
  }
})();

if (pageType === 'product') {
  //-----------------------------------------
  // Code that only runs on product pages.
  //-----------------------------------------
}

if (pageType === 'collection') {
  //-----------------------------------------
  // Code that only runs on collection pages.
  //-----------------------------------------
}
